module.exports = [{
      plugin: require('C:/xampp/htdocs/strapi/gatsby/hello-world/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
